/**
 * 广告位置信息
 * https://kapok.huaban.com/dashboard/promotions/positions
 * https://doc.huanleguang.com/pages/viewpage.action?pageId=201236836
 */
export const AD_POSITION = {
  /**吸顶 */
  TOP: 51,
  /**指定页面吸顶 */
  TOP_PAGE: 59,
  /**导航右上角 九宫格边上*/
  NAV_TOP_RIGHT: 58,
  /** 发现页顶部 */
  DISCOVERY_TOP: 43,
  /**发现页瀑布流跨列Banner */
  DISCOVERY_WATERFALL_BANNER: 61,

  /**pc-新搜索页-固定1**/
  SEARCH_WATERFALL_FIXED_1: 47,
  /**pc-新搜索页-固定2**/
  SEARCH_WATERFALL_FIXED_2: 48,
  /**pc-新搜索页-瀑布流	PC 新版搜索结果瀑布流第11～20随机出现 */
  SEARCH_WATERFALL_RANDOM_1: 49,
  /** pc-新搜索页-瀑布流4: PC 新搜索页瀑布流第四个采集*/
  SEARCH_WATERFALL_4: 56,

  /** pc-新搜索页-每页插一*/
  SEARCH_WATERFALL_PER_PAGE: 62,
  /** pc-新发现页-每页插一*/
  DISCOVERY_WATERFALL_PER_PAGE: 63,
  /** pc-新采集详情页-每页插一*/
  PINDETAIL_WATERFALL_PER_PAGE: 64,
};

export const ADS_TYPE = {
  IMAGE: "image",
  HTML: "html",
  NONE: "none",
};
